import { GetQueryParams, GetQueryResponse } from '../../../types/api.type';
import { FeaturedIngredient } from '../../../types/content.type';
import { sfcApi } from '../../api';
export interface FeaturedIngredientCreateUpdateValues {
  id?: number;
  name: string;
  content: string;
  uncovering_instructions: string;
  image?: File;
  image_source: string;
}
export const featuredIngredientApi = sfcApi.injectEndpoints({
  endpoints: (builder) => ({
    getFeaturedIngredients: builder.query<GetQueryResponse, GetQueryParams | void>({
      query: (params) => ({
        url: `featured-ingredients${params?.scope ? `?scope=${params.scope}` : ''}`,
        method: 'POST',
        body: params?.data
      }),
      providesTags: ['FeaturedIngredients']
    }),
    getFeaturedIngredient: builder.query<{ featuredIngredient: FeaturedIngredient }, number>({
      query: (id) => `featured-ingredients/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'FeaturedIngredients', id }]
    }),
    createFeaturedIngredient: builder.mutation<
      { featuredIngredient: FeaturedIngredient },
      FeaturedIngredientCreateUpdateValues
    >({
      query: (data) => {
        const formData = new FormData();
        let payload: any = {
          url: `featured-ingredients/create`,
          method: 'POST',
          body: data
        };
        Object.entries(data).forEach(([key, value]) => formData.append(key, value));
        if (data.image?.name) {
          payload.formData = true;
        }
        if (!data?.image?.name) {
          formData.delete('image');
        }
        payload.body = formData;

        return payload;
      },
      invalidatesTags: ['FeaturedIngredients']
    }),

    updateFeaturedIngredient: builder.mutation<
      { featuredIngredient: FeaturedIngredient },
      FeaturedIngredientCreateUpdateValues
    >({
      query: (data) => {
        const { id } = data;
        delete data.id;
        const formData = new FormData();
        let payload: any = {
          url: `featured-ingredients/update/${id}`,
          method: 'PUT',
          body: data
        };
        Object.entries(data).forEach(([key, value]) => formData.append(key, value));
        if (data.image?.name) {
          payload.formData = true;
        }
        if (!data?.image?.name) {
          formData.delete('image');
        }
        payload.body = formData;

        return payload;
      },
      invalidatesTags: (_result, _error, { id }) => [{ type: 'FeaturedIngredients', id }, 'FeaturedIngredients']
    }),

    deleteFeaturedIngredient: builder.mutation<{ featuredIngredient: FeaturedIngredient }, number>({
      query: (id) => ({
        url: `featured-ingredients/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['FeaturedIngredients']
    })
  })
});

export const {
  useGetFeaturedIngredientsQuery,
  useGetFeaturedIngredientQuery,
  useCreateFeaturedIngredientMutation,
  useUpdateFeaturedIngredientMutation,
  useDeleteFeaturedIngredientMutation
} = featuredIngredientApi;
